import React, { ReactNode } from 'react'
import type { PermissionDecision, PermissionEvaluationInput, PermissionSurface } from '../../types/permissions'
import { usePermissionDecision } from '../../permissions'

type ActionGuardProps = {
  children: ReactNode
  surface?: PermissionSurface
  decision?: PermissionDecision
  input?: PermissionEvaluationInput
  fallback?: ReactNode
}

const ActionGuard: React.FC<ActionGuardProps> = ({ children, surface, decision, input, fallback = null }) => {
  const computedDecision = usePermissionDecision(surface, input)
  const resolvedDecision = decision ?? computedDecision

  if (!resolvedDecision.allowed) {
    return <>{fallback}</>
  }

  return <>{children}</>
}

export default ActionGuard
